// @ts-nocheck
import Accordion from "@insite/mobius/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import Typography from "@insite/mobius/Typography";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";

const StyleguideAccordions: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Accordions" sectionId={sectionId}>
            <Accordion headingLevel={2}>
                <ManagedAccordionSection initialExpanded={false} title="Specifications">
                    <Typography variant="p">
                        In molestie nisl ut risus posuere, sit amet efficitur enim convallis. Integer cursus imperdiet
                        suscipit. Aenean ut libero a neque ultricies lacinia. Nam velit quam, sollicitudin nec tempor
                        at, posuere sed metus. Donec pellentesque at nisl eget faucibus. Aenean ac quam at felis
                        interdum tempor nec quis tortor. Quisque viverra quam lorem, id finibus nunc hendrerit vitae.
                    </Typography>
                    <Typography variant="p">
                        Donec commodo felis quis dui finibus convallis. Praesent sit amet lacus vitae magna imperdiet
                        viverra. Aliquam vestibulum sed nisl eu vehicula. Pellentesque pellentesque semper dui, id
                        pretium orci gravida eu. In euismod fermentum semper. Aliquam sed lacinia purus. Vestibulum
                        sodales rhoncus leo. Nulla euismod maximus sapien ac dapibus. Curabitur in magna velit. Donec
                        tristique dolor sollicitudin, laoreet tellus in, congue tellus.
                    </Typography>
                </ManagedAccordionSection>
                <ManagedAccordionSection initialExpanded={false} title="Documents">
                    <Typography variant="p">
                        Donec commodo felis quis dui finibus convallis. Praesent sit amet lacus vitae magna imperdiet
                        viverra. Aliquam vestibulum sed nisl eu vehicula. Pellentesque pellentesque semper dui, id
                        pretium orci gravida eu. In euismod fermentum semper. Aliquam sed lacinia purus. Vestibulum
                        sodales rhoncus leo. Nulla euismod maximus sapien ac dapibus. Curabitur in magna velit. Donec
                        tristique dolor sollicitudin, laoreet tellus in, congue tellus.
                    </Typography>
                </ManagedAccordionSection>
                <ManagedAccordionSection initialExpanded={false} title="Warranty">
                    <Typography variant="p">
                        In molestie nisl ut risus posuere, sit amet efficitur enim convallis. Integer cursus imperdiet
                        suscipit. Aenean ut libero a neque ultricies lacinia. Nam velit quam, sollicitudin nec tempor
                        at, posuere sed metus. Donec pellentesque at nisl eget faucibus. Aenean ac quam at felis
                        interdum tempor nec quis tortor. Quisque viverra quam lorem, id finibus nunc hendrerit vitae.
                    </Typography>
                </ManagedAccordionSection>
            </Accordion>
        </StyleguideSection>
    );
};

export default StyleguideAccordions;
